import React from "react";
import styled from "styled-components";

const Button = ({ type, className, children, disabled, onClick, id, ref }) => {
  return (
    <>
      {type === "primary" ? (
        <PrimaryButton
          className={className}
          type={type}
          disabled={disabled}
          onClick={onClick}
          id={id}
          ref={ref}
        >
          {children}
        </PrimaryButton>
      ) : (
        ""
      )}

      {type === "connect" ? (
        <ConnectButton
          className={className}
          type={type}
          disabled={disabled}
          onClick={onClick}
          id={id}
          ref={ref}
        >
          {children}
        </ConnectButton>
      ) : (
        ""
      )}

      {type === "default" ? (
        <DefaultButton
          className={className}
          type={type}
          disabled={disabled}
          onClick={onClick}
          id={id}
          ref={ref}
        >
          {children}
        </DefaultButton>
      ) : (
        ""
      )}
    </>
  );
};

const BaseButton = styled.button`
  font-size: 16px;
  border-radius: 3px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
  :disabled {
    opacity: 0.8;
    color: grey !important;
    cursor: not-allowed;
  }
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

const PrimaryButton = styled(BaseButton)`
  z-index: 1;
  overflow: hidden;
  color: white;
  background: #1f2399;
  :before {
    width: calc(100% + 100px);
    transition: 0.3s ease-in-out;
    content: "";
    position: absolute;
    background-color: white;
    height: 100%;
    right: -50px;
    transform: skewX(40deg) translateX(-100%);
    z-index: -1;
  }
  transition: 0.3s ease-in-out;
  :hover:not([disabled]) {
    :before {
      transform: skewX(30deg) translateX(0);
    }
    color: #1f2399;
  }
`;

const DefaultButton = styled(BaseButton)``;

const ConnectButton = styled(BaseButton)`
  background-color: white;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.15);
`;

export default Button;
